<template>
  <v-app>
    <v-main class="emptyBackground">
      <router-view />
    </v-main>
    <Notify></Notify>
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'

export default {
  components: {
    Notify
  }
}
</script>
